import { Paper, Skeleton, Typography } from '@mui/material'
import React from 'react'
import TextEllipsis from '../text/TextEllipsis'
import TextOverflowLine from '../text/TextOverflowLine'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CardKeyValue = ({ title, value, className, tooltip = true, lines = 1, loading, onClick, icon, iconClassName = 'text-3xl' }) => {
  return (
    <Paper 
    onClick={onClick}
    className={
      ['px-2 py-2 flex gap-1 items-center ', className].join(' ')
    }>
      {icon && (
        <FontAwesomeIcon
          icon={icon}
          className={`${iconClassName}`}
        />
      )}
      <div className='overflow-hidden flex flex-col items-start justify-center gap-1 h-full w-full'>
        { tooltip ? (
          lines > 1 ? (
            <TextOverflowLine id={`card-key-${title}`} className='w-full text-center' placement='top' lines={lines}>
              {loading ? <Skeleton width={'100%'} /> : value}
            </TextOverflowLine>
          ) : (
            <TextEllipsis id={`card-key-${title}`}  className='w-full text-center'>
              {loading ? <Skeleton width={'100%'} /> : value}
            </TextEllipsis>
          )
          
        ) : (
          loading ? <Skeleton width={'100%'}  /> : <Typography variant='inherit' className='text-center w-full'>{value}</Typography>
        )}
        <Typography variant='inherit' className='font-bold text-xs text-center w-full' color='primary' component='p'>
          {title}
        </Typography>
      </div>
    </Paper>
  )
}

export default CardKeyValue